import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ConversationConfig {
  toolId: string;
  organizationSize: string;
  industry: string;
  templateType: string;
  durationMonths: number;
  includeSkillsAssessment: boolean;
  includeObjectives: boolean;
  checkInFrequency: string;
  additionalContext: string;
  selectedStageTypes: string[];
  selectedSkillFrameworks: string[];
}

interface ConversationGenerationResponse {
  template: {
    id: string;
    name: string;
    description: string;
    template_type: string;
    duration_months: number;
    stages: Array<{
      id: string;
      name: string;
      description: string;
      stage_type: string;
      order_index: number;
      timing_weeks: number | null;
      is_optional: boolean;
      questions: Array<{
        id: string;
        question_text: string;
        question_type_id: string;
        respondent_type: string;
        order_index: number;
        is_required: boolean;
        options: any;
      }>;
      objectives: Array<{
        id: string;
        objective_text: string;
        is_placeholder: boolean;
        order_index: number;
      }>;
    }>;
  };
}

export const useConversationGeneration = () => {
  return useMutation({
    mutationFn: async (config: ConversationConfig): Promise<ConversationGenerationResponse> => {
      const { data, error } = await supabase.functions.invoke('generate-conversation-template', {
        body: { config }
      });

      if (error) {
        console.error('Error generating conversation template:', error);
        throw new Error('Failed to generate conversation template');
      }

      return data as ConversationGenerationResponse;
    },
  });
};